class SharedDrop {
  path: string;
  client: any;
  constructor(client: any) {
    this.client = client;
    this.path = 'drops/groups/shared';
  }
  async get(id: string, options = {}) {
    const response = await this.client.get(`${this.path}/${id}`, options);
    return response.data;
  }
  async list(params = {}, options = {}) {
    const localOptions = {
      params,
    };
    const response = await this.client.get(
      this.path,
      Object.assign(localOptions, options)
    );
    return {
      count: response.headers['x-results-count'],
      hasMore: response.headers['x-has-more'],
      results: response.data,
    };
  }
}

export default SharedDrop;
